import { Pipe, PipeTransform } from '@angular/core';
import { InspectionItemBase, TriStateInspectionItem, TriStateValue } from '@raptor-fe/core';

/**
 * Returns a Bootstrap badge CSS class for a TriState item's recorded answer.
 * Kept separate from InspectionItemBadgeClassPipe, whose contract is result-to-colour: TriState
 * carries no result, so its colour comes from the answer itself. An unanswered item returns empty
 * so the caller can render an absence rather than a neutral badge.
 */
@Pipe({ name: 'triStateBadgeClass' })
export class TriStateBadgeClassPipe implements PipeTransform {
    transform(value: InspectionItemBase): string {
        switch ((value as TriStateInspectionItem).value) {
            case TriStateValue.Yes:
                return 'text-bg-success';
            case TriStateValue.NotApplicable:
                return 'text-bg-secondary';
            case TriStateValue.No:
                return 'text-bg-danger';
            default:
                return '';
        }
    }
}
